import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import MD5 from 'crypto-js/md5';
import logoG4 from '../../assets/img/theme/iconG4.png';

/**
 * Componente para exibir fotos de perfil de agentes com base no login do agente, com fallback para o logo padrão
 */
export const AgentProfilePictureByLogin = React.memo(
  ({ login, alt, className, style }) => {
    const getDomain = useCallback(() => {
      let url =
        window.location.hostname === 'localhost'
          ? process.env.REACT_APP_PROXY_URL
          : window.location.origin;

      // Remove o protocolo
      url = url.replace(/^https?:\/\//, '');

      // Remove a porta para localhost
      if (window.location.hostname === 'localhost' && url.indexOf(':') !== -1) {
        url = url.substring(0, url.indexOf(':'));
      }

      if (url.indexOf('/') !== -1) {
        url = url.substring(0, url.indexOf('/'));
      }
      return url;
    }, []);

    // Gera a URL da imagem com base no login
    const imageUrl = useMemo(() => {
      if (!login) return logoG4;
      const domain = getDomain();
      const protocol = window.location.protocol;
      const hashedLogin = MD5(login);
      return `${protocol}//${domain}/configuration/src/public/img/${hashedLogin}.png`;
    }, [login, getDomain]);

    const handleError = (e) => {
      e.currentTarget.onerror = null; // Previne loops infinitos de erro
      e.currentTarget.src = logoG4;
    };

    return (
      <img
        src={imageUrl}
        onError={handleError}
        alt={alt || `Perfil do agente ${login}`}
        className={className}
        style={style}
      />
    );
  }
);

AgentProfilePictureByLogin.propTypes = {
  login: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};

AgentProfilePictureByLogin.displayName = 'AgentProfilePictureByLogin';
